import type { CreateEquipmentNodeType } from '@/nodes/types';
import type { GuideNodeId } from '@rock/types';
import { outgoingHandles } from '@rock/types';
import { Handle, type NodeProps, Position } from '@xyflow/react';
import { type FC, useContext } from 'react';
import { FlowParamsContext } from '../app/FlowInitializer';
import { EquipmentTypeDisplay } from './NodeUI';

export const CreateEquipmentNode: FC<NodeProps<CreateEquipmentNodeType>> = ({ id, data }) => {
    const paths = outgoingHandles['create-equipment'](id as GuideNodeId, data);
    const { spaceId } = useContext(FlowParamsContext);

    return (
        <div className="border-1 rounded-lg m-1 px-3 py-2 bg-orange-50 border-orange-300">
            <div className="flex flex-col items-center justify-center ">
                <div className="text-sm font-medium text-orange-900">CREATE EQUIPMENT</div>
                {data.equipmentTypeId && (
                    <div className="flex flex-col items-center justify-center p-3">
                        <EquipmentTypeDisplay spaceId={spaceId} typeId={data.equipmentTypeId} />
                    </div>
                )}
            </div>

            <Handle type="target" position={Position.Left} />
            <Handle type="source" id={paths.next} position={Position.Right} />
        </div>
    );
};
